var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    [
      _c("div", { staticClass: "disp-flex mb-5" }, [
        _c(
          "div",
          [
            _c("el-button", { attrs: { type: "text" } }, [
              _vm.item.action
                ? _c("i", {
                    staticClass: "el-icon-view",
                    attrs: { size: "large" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("b", [_vm._v(_vm._s(_vm.$tc(_vm.item.message_code)))])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm.item.status && _vm.item.status === "CANCELED"
              ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "DONE"
              ? _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "PROCESSING"
              ? _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "FAILED"
              ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          !_vm.item.invoice_dispute_by_reference.resolved_at
            ? _c("div", { staticClass: "mb-10" }, [
                _c(
                  "div",
                  { staticClass: "mb-5", staticStyle: { color: "#303133" } },
                  [
                    _c("svg-icon", { attrs: { "icon-class": "user" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-13" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.item.invoice_dispute_by_reference &&
                              _vm.item.invoice_dispute_by_reference.tasks &&
                              _vm.item.invoice_dispute_by_reference.tasks
                                .length > 0 &&
                              _vm.item.invoice_dispute_by_reference.tasks[0]
                                .assignee_by_reference &&
                              _vm.item.invoice_dispute_by_reference.tasks[0]
                                .assignee_by_reference.username
                              ? _vm.item.invoice_dispute_by_reference.tasks[0]
                                  .assignee_by_reference.username
                              : _vm.$t("timeline.unassigned")
                          )
                        )
                      ])
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.invoice_dispute_by_reference.dispute_code_by_reference
            ? [
                _c(
                  "el-tag",
                  {
                    staticClass: "mb-5",
                    attrs: { size: "mini", effect: "plain" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$translate.dispute_code(
                            _vm.item.invoice_dispute_by_reference
                              .dispute_code_by_reference.code
                          )
                        ) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.item.note_by_reference
            ? [
                _c(
                  "div",
                  {
                    staticClass: "mb-5 fs-13",
                    staticStyle: { color: "rgb(115, 115, 115) !important" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.item.note_by_reference.note) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.item.invoice_dispute_by_reference &&
          _vm.item.invoice_dispute_by_reference.invoice_by_reference
            ? [
                _c("div", { staticClass: "mb-5 fs-13" }, [
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("regardsTo")) +
                        "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.$tc("invoiceWithTotal", 1, {
                            value:
                              _vm.item.invoice_dispute_by_reference
                                .invoice_by_reference.invoice_number
                          })
                        ) +
                        "\n\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-tag",
                  {
                    staticClass: "cursor-pointer mr-5 mb-5",
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.handleInvoiceClick(
                          _vm.item.invoice_dispute_by_reference
                            .invoice_by_reference
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "hover-underline" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.item.invoice_dispute_by_reference
                              .invoice_by_reference.invoice_number
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-timeline",
            { staticClass: "mt-20 pl-0 event-timeline" },
            [
              _vm.item.invoice_dispute_by_reference.resolved_at &&
              !_vm.item.invoice_dispute_by_reference.auto_resolved &&
              _vm.item.invoice_dispute_by_reference.resolved_by &&
              _vm.item.invoice_dispute_by_reference.tasks &&
              _vm.item.invoice_dispute_by_reference.tasks.length > 0 &&
              _vm.item.invoice_dispute_by_reference.tasks[0].executed_at &&
              !_vm.item.invoice_dispute_by_reference.tasks[0].canceled_at
                ? _c(
                    "el-timeline-item",
                    {
                      attrs: {
                        color: "#ed6b1c",
                        timestamp: _vm._f("parseTime")(
                          _vm.item.invoice_dispute_by_reference.tasks[0]
                            .executed_at,
                          "{d}-{m}-{y}"
                        )
                      }
                    },
                    [
                      _c("div", { staticClass: "timelineitem" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("timeline.extended_by")) +
                              "  " +
                              _vm._s(
                                _vm.item.invoice_dispute_by_reference.tasks[0]
                                  .executed_by_by_reference.username
                              )
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.invoice_dispute_by_reference.resolved_at &&
              !_vm.item.invoice_dispute_by_reference.auto_resolved &&
              _vm.item.invoice_dispute_by_reference.tasks &&
              _vm.item.invoice_dispute_by_reference.tasks.length > 0 &&
              _vm.item.invoice_dispute_by_reference.tasks[0].canceled_at
                ? _c(
                    "el-timeline-item",
                    {
                      attrs: {
                        color: "#ed6b1c",
                        timestamp: _vm._f("parseTime")(
                          _vm.item.invoice_dispute_by_reference.tasks[0]
                            .canceled_at,
                          "{d}-{m}-{y}"
                        )
                      }
                    },
                    [
                      _c("div", { staticClass: "timelineitem" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("timeline.canceled_by")) +
                              " " +
                              _vm._s(
                                _vm.item.invoice_dispute_by_reference.tasks[0]
                                  .canceled_by_by_reference.username
                              )
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.invoice_dispute_by_reference.resolved_at &&
              _vm.item.invoice_dispute_by_reference.auto_resolved &&
              _vm.item.invoice_dispute_by_reference.tasks &&
              _vm.item.invoice_dispute_by_reference.tasks.length > 0 &&
              _vm.item.invoice_dispute_by_reference.tasks[0].executed_at &&
              !_vm.item.invoice_dispute_by_reference.tasks[0].canceled_at
                ? _c(
                    "el-timeline-item",
                    {
                      attrs: {
                        color: "#ed6b1c",
                        timestamp: _vm._f("parseTime")(
                          _vm.item.invoice_dispute_by_reference.tasks[0]
                            .executed_at,
                          "{d}-{m}-{y}"
                        )
                      }
                    },
                    [
                      _c("div", { staticClass: "timelineitem" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("timeline.auto_resolved")))
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.invoice_dispute_by_reference.resolved_at &&
              _vm.item.invoice_dispute_by_reference.auto_resolved &&
              _vm.item.invoice_dispute_by_reference.tasks &&
              _vm.item.invoice_dispute_by_reference.tasks.length > 0 &&
              _vm.item.invoice_dispute_by_reference.tasks[0].canceled_at
                ? _c(
                    "el-timeline-item",
                    {
                      attrs: {
                        color: "#ed6b1c",
                        timestamp: _vm._f("parseTime")(
                          _vm.item.invoice_dispute_by_reference.tasks[0]
                            .canceled_at,
                          "{d}-{m}-{y}"
                        )
                      }
                    },
                    [
                      _c("div", { staticClass: "timelineitem" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("timeline.auto_canceled")))
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-timeline-item",
                {
                  attrs: {
                    color: "#ed6b1c",
                    timestamp: _vm._f("parseTime")(
                      _vm.item.invoice_dispute_by_reference.from,
                      "{d}-{m}-{y}"
                    )
                  }
                },
                [
                  _c("div", { staticClass: "timelineitem" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.item.person_by_reference &&
                            _vm.item.person_by_reference.username
                            ? _vm.item.person_by_reference.username
                            : _vm.$t("system")
                        )
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      (_vm.item.metadata &&
        _vm.item.metadata.channels &&
        _vm.item.metadata.channels[0].reason) ||
      (_vm.item.metadata &&
        _vm.item.metadata.channels &&
        _vm.item.metadata.channels[0].callResult)
        ? _c(
            "el-collapse",
            [
              _c(
                "el-collapse-item",
                {
                  attrs: { title: _vm.$t("moreInfo"), name: `${_vm.index}-1` }
                },
                [
                  _vm.item.metadata &&
                  _vm.item.metadata.channels &&
                  _vm.item.metadata.channels[0]
                    ? [
                        _vm.item.metadata &&
                        _vm.item.metadata.channels[0].reason
                          ? [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("reasonForCall")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.item.metadata
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(115, 115, 115) !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.item.metadata.channels[0].reason
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.metadata &&
                        _vm.item.metadata.channels[0].callResult
                          ? [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("callResult")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.item.metadata
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(115, 115, 115) !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.item.metadata.channels[0]
                                              .callResult
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.action_invoices &&
                  _vm.item.action_invoices.length === 1
                    ? [
                        _c(
                          "div",
                          { staticClass: "mt-10" },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("regardsTo")) +
                                    " " +
                                    _vm._s(_vm.$tc("invoice")) +
                                    " "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.item.action_by_reference
                              .primary_invoice_by_reference.invoice_number
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "cursor-pointer",
                                    attrs: { size: "mini" }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "hover-underline",
                                        attrs: {
                                          to: {
                                            name: "invoice-detail",
                                            params: {
                                              reference:
                                                _vm.item.action_by_reference
                                                  .primary_invoice_by_reference
                                                  .invoice_number
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.item.action_by_reference
                                                .primary_invoice_by_reference
                                                .invoice_number
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }